// extracted by mini-css-extract-plugin
export var tosLink = "_bf-0";